export default {
  CATEGORY: 'category',
  MENU_ITEM: 'menuItem',
  MODIFIER_GROUP: 'modifierGroup',
  MODIFIER: 'modifier'
};
